import React, {PureComponent} from "react"
import SelectInput from "./SelectInput";
import Input from "./Input";

export default class LocationBlock extends PureComponent {
    constructor() {
        super(...arguments);

        this.state = {
            regions: {},
            districts: {},
            cities: {},
            streets: {},
            building_numbers: {},
            streetManual: Boolean(this.props.street_name_manual)
        }

        this.handleChangeRegion = this.handleChangeRegion.bind(this);
        this.handleChangeDistrict = this.handleChangeDistrict.bind(this);
        this.handleChangeCity = this.handleChangeCity.bind(this);
        this.handleChangeStreet = this.handleChangeStreet.bind(this);
    }

    updateRegions() {
        axios.get(`/locations/regions`)
            .then((res) => {
                let regions = {};
                res.data.Entries.Entry.forEach((region) => {
                    regions[region.REGION_ID] = region.REGION_UA;
                })

                this.setState({regions: regions});
            })
    }

    updateDistricts(region_id) {
        if (region_id) {
            axios.get(`/locations/regions/${region_id}/districts`)
                .then((res) => {
                    let districts = {};
                    res.data.Entries.Entry.forEach((district) => {
                        districts[district.DISTRICT_ID] = district.DISTRICT_UA;
                    })

                    this.setState({districts: districts});
                })
        }
    }

    updateCities(region_id, district_id) {
        if (region_id && district_id) {
            axios.get(`/locations/regions/${region_id}/districts/${district_id}/cities`)
                .then((res) => {
                    let cities = {};
                    res.data.Entries.Entry.forEach(city => {
                        cities[city.CITY_ID] = city.CITY_UA;
                    })

                    this.setState({cities: cities});
                })
        }
    }

    updateStreets(region_id, district_id, city_id) {
        if (region_id && district_id && city_id) {
            axios.get(`/locations/regions/${region_id}/districts/${district_id}/cities/${city_id}/streets`)
                .then((res) => {
                    let streets = {};
                    res.data.Entries.Entry.forEach(street => {
                        streets[street.STREET_ID] = street.SHORTSTREETTYPE_UA + street.STREET_UA;
                    })
                    this.setState({streets: streets});
                })
                .catch((err) => {
                    this.setState({streetManual: true})
                })
        }
    }

    updatePostcode(street_id) {
        if (street_id) {
            axios.get(`/locations/indexes/get-index-by-street-id/${street_id}`)
                .then((res) => {
                    let street = res.data.Entries.Entry.pop();
                    this.setState({
                        postcode: street.POSTCODE
                    })
                    this.props.onChange('postcode', street.POSTCODE);
                })
                .catch((err) => {

                })
        }
    }

    componentDidMount() {
        this.updateRegions();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.region_id !== this.props.region_id) {
            this.props.onChange('district_id', '');
            this.props.onChange('city_id', '');
            this.props.onChange('street_id', '');
            this.props.onChange('postcode', '');
            this.setState({streetManual: false})
        }
        if (prevProps.district_id !== this.props.district_id) {
            this.props.onChange('city_id', '');
            this.props.onChange('street_id', '');
            this.props.onChange('postcode', '');
            this.setState({streetManual: false})
        }
        if (prevProps.city_id !== this.props.city_id) {
            this.props.onChange('street_id', '');
            this.props.onChange('postcode', '');
            this.setState({streetManual: false})
        }
        if (prevProps.street_id !== this.props.street_id) {
            this.props.onChange('postcode', '');
            this.setState({streetManual: false})
        }
    }

    handleChangeRegion(key, region_id) {
        this.props.onChange('region_id', region_id);

        this.updateDistricts(region_id);
    }

    handleChangeDistrict(key, district_id) {
        this.props.onChange('district_id', district_id);

        this.updateCities(this.props.region_id, district_id);
    }

    handleChangeCity(key, city_id) {
        this.props.onChange('city_id', city_id);

        this.updateStreets(this.props.region_id, this.props.district_id, city_id)
    }

    handleChangeStreet(key, street_id) {
        this.props.onChange('street_id', street_id);

        this.updatePostcode(street_id);
    }

    render() {
        const {
            region_id,
            district_id,
            city_id,
            street_id,
            street_name_manual,
            postcode,
            building_number,
            building_drop,
            building_corpus_number,
            building_corpus_drop,
            apartment_number,
            apartment_number_drop,
            errors
        } = this.props;
        const {regions, districts, cities, streets, streetManual} = this.state;

        return (
            <div>
                <hr/>
                <h4 className="my-4 font-weight-bolder">Адреса об'єкта газопостачання</h4>
                <div className="row">
                    <div className="col-sm-6">
                        <SelectInput
                            label='Область'
                            attribute={'region_id'}
                            value={region_id}
                            options={regions}
                            onChange={this.handleChangeRegion}
                            required={true}
                            error={errors.region_id}
                        />
                    </div>
                    <div className="col-sm-6">
                        <SelectInput
                            label='Район'
                            attribute={'district_id'}
                            value={district_id}
                            options={districts}
                            onChange={this.handleChangeDistrict}
                            required={true}
                            isDisabled={!Boolean(region_id)}
                            error={errors.district_id}
                        />
                    </div>
                    <div className="col-sm-6">
                        <SelectInput
                            label='Населений пункт'
                            attribute={'city_id'}
                            value={city_id}
                            options={cities}
                            onChange={this.handleChangeCity}
                            required={true}
                            isDisabled={!Boolean(district_id)}
                            error={errors.city_id}
                        />
                    </div>
                    <div className="col-sm-6">
                        {streetManual ?
                            <div>
                                <div className="float-right">
                                    <a className="cursor-pointer" onClick={() => this.setState({streetManual: false})}>Вибрати зі списку</a>
                                </div>
                                <Input attr={'street_name_manual'} value={street_name_manual} label='Вулиця'
                                       onChange={this.props.onChange}
                                       required={true}
                                       error={errors.street_name_manual}
                                />
                            </div>
                            :
                            <div>
                                <div className="float-right">
                                    <a className="cursor-pointer" onClick={() => this.setState({streetManual: true})}>Ввести вручну</a>
                                </div>
                                <SelectInput
                                    label='Вулиця'
                                    attribute={'street_id'}
                                    value={street_id}
                                    options={streets}
                                    onChange={this.handleChangeStreet}
                                    isDisabled={!Boolean(city_id)}
                                    required={true}
                                    error={errors.street_id}
                                />
                            </div>
                        }
                    </div>
                    <div className="col-sm-6">
                        <Input
                            attr={'postcode'}
                            value={postcode}
                            label='Індекс'
                            placeholder="Введіть індекс"
                            type={'number'}
                            onChange={this.props.onChange}
                            required={true}
                            error={errors.postcode}
                        />
                    </div>
                    <div className="col-sm-3">
                        <Input
                            attr={'building_number'}
                            value={building_number}
                            label='Номер будинку'
                            placeholder='Введіть номер будинку'
                            type={'number'}
                            onChange={this.props.onChange}
                            required={true}
                            error={errors.building_number}
                        />
                    </div>
                    <div className="col-sm-3">
                        <Input
                            attr={'building_drop'}
                            value={building_drop}
                            label='Дріб будинку'
                            placeholder="Введіть дріб будинку"
                            onChange={this.props.onChange}
                            error={errors.building_drop}
                        />
                    </div>
                    <div className="col-sm-3">
                        <Input
                            attr={'building_corpus_number'}
                            value={building_corpus_number}
                            label='Номер корпусу'
                            placeholder="Введіть номер корпусу"
                            type={'number'}
                            onChange={this.props.onChange}
                            error={errors.building_corpus_number}
                        />
                    </div>
                    <div className="col-sm-3">
                        <Input
                            attr={'building_corpus_drop'}
                            value={building_corpus_drop}
                            label='Дріб корпусу'
                            placeholder="Введіть дріб корпусу"
                            onChange={this.props.onChange}
                            error={errors.building_corpus_drop}
                        />
                    </div>
                    <div className="col-sm-3">
                        <Input
                            attr={'apartment_number'}
                            value={apartment_number}
                            label='Номер квартири'
                            placeholder="Введіть номер квартири"
                            type={'number'}
                            onChange={this.props.onChange}
                            error={errors.apartment_number}
                        />
                    </div>
                    <div className="col-sm-3">
                        <Input
                            attr={'apartment_number_drop'}
                            value={apartment_number_drop}
                            label='Дріб квартири'
                            placeholder="Введіть дріб квартири"
                            onChange={this.props.onChange}
                            error={errors.apartment_number_drop}
                        />
                    </div>
                </div>
            </div>
        )
    }
}
